import { render, staticRenderFns } from "./PersonaAdd.vue?vue&type=template&id=6f5da939&scoped=true&"
import script from "./PersonaAdd.vue?vue&type=script&lang=js&"
export * from "./PersonaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5da939",
  null
  
)

export default component.exports